import {
  Badge,
  Box,
  ButtonBase,
  Divider,
  styled,
  useMediaQuery,
} from "@mui/material";
import AppAvatar from "components/avatars/AppAvatar";
import FlexBox from "components/flexbox/FlexBox";
import { H6, Small, Tiny } from "components/Typography";
import { AuthContext } from "contexts/AuthContext";
import { Fragment, useContext, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PopoverLayout from "./PopoverLayout"; // styled components
import API from "services/api"; 
import { decodeToken } from "react-jwt"

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  padding: 5,
  marginLeft: 4,
  borderRadius: 30,
  border: `1px solid ${theme.palette.divider}`,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const StyledSmall = styled(Small)(({ theme }) => ({
  display: "block",
  cursor: "pointer",
  padding: "5px 1rem",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const ProfilePopover = () => {
  const { user, role, logout } = useContext(AuthContext);
  let token = localStorage.getItem("access_token")
  token = decodeToken(token)
  const idRole = token?.role
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const upSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const roles = localStorage.getItem("roles")? JSON.parse(localStorage.getItem("roles")) : [];

  const handleMenuItem = (path) => {
    navigate(path);
    setOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
    toast.success("You Logout Successfully");
  };

  const handleSwitchRole = async (roleId) => {
    try {
      const accessToken = localStorage.getItem("access_token");
      const res = await API.switchRole({ accessToken, roleId });
      if (res.data.success) {
        localStorage.setItem("access_token", res.data.data.accessToken);
        localStorage.setItem("refresh_token", res.data.data.refreshToken);
        // Jika kamu simpan role di localStorage atau context, update juga
        localStorage.setItem("role", res.data.data.role);
        toast.success("Role switched to " + res.data.data.role);
        window.location.reload(); // reload untuk refresh permission/menu
      } else {
        toast.error(res.data.message || "Failed to switch role");
      }
    } catch (err) {
      toast.error("Failed to switch role");
    }
  };

  return (
    <Fragment>
      <StyledButtonBase
        disableRipple
        ref={anchorRef}
        onClick={() => setOpen(true)}
      >
        <Badge
          overlap="circular"
          variant="dot"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          sx={{
            alignItems: "center",
            "& .MuiBadge-badge": {
              width: 11,
              height: 11,
              right: "4%",
              borderRadius: "50%",
              border: "2px solid #fff",
              backgroundColor: "success.main",
            },
          }}
        >
          {upSm && (
            <Small mx={1} color="text.secondary">
              Hi,
              <Small fontWeight="600" display="inline">
                {localStorage.getItem("user")}
              </Small>
            </Small>
          )}
          <AppAvatar
            src={user?.avatar || "/static/avatar/001-man.svg"}
            sx={{
              width: 28,
              height: 28,
            }}
          />
        </Badge>
      </StyledButtonBase>

      <PopoverLayout
        hiddenViewButton
        maxWidth={230}
        minWidth={200}
        popoverOpen={open}
        anchorRef={anchorRef}
        popoverClose={() => setOpen(false)}
        title={
          <FlexBox alignItems="center" gap={1}>
            <AppAvatar
              src={user?.avatar || "/static/avatar/001-man.svg"}
              sx={{
                width: 35,
                height: 35,
              }}
            />

            <Box>
              <H6>{localStorage.getItem("user") || "User"}</H6>
              {/* <Tiny display="block" fontWeight={500} color="text.disabled">
                Edit 
              </Tiny> */}
            </Box>
          </FlexBox>
        }
      >
        <Box>
          {/* <StyledSmall onClick={() => handleMenuItem("/dashboard/profile")}>
            Set Status
          </StyledSmall>

          <StyledSmall onClick={() => handleMenuItem("/dashboard/profile")}>
            Profile & Account
          </StyledSmall>

          <StyledSmall onClick={() => handleMenuItem("/dashboard/account")}>
            Settings
          </StyledSmall>

          <StyledSmall onClick={() => handleMenuItem("/dashboard/team-member")}>
            Manage Team
          </StyledSmall>

          <Divider
            sx={{
              my: 1,
            }}
          /> */}
          <Box pt={1}>
            {roles.length > 1 && (
              <>
                {roles
                  .filter((r) => r._id !== idRole) // KECUALIKAN role aktif
                  .map((r) => (
                    <StyledSmall key={r._id} onClick={() => handleSwitchRole(r._id)}>
                      Switch to {r.name} Role
                    </StyledSmall>
                  ))}
                  <Divider sx={{ my: 1 }} />
              </>
            )}
          </Box>
          <StyledSmall
            onClick={() => {
              handleLogout();
              // toast.error("You Logout Successfully");
            }}
          >
            Sign Out
          </StyledSmall>
        </Box>
      </PopoverLayout>
    </Fragment>
  );
};

export default ProfilePopover;
